exports.ByName = {
  NotReady: { Id: 1, Name: 'NotReady' },
  ReadyToRun: { Id: 2, Name: 'ReadyToRun' },
  Running: { Id: 3, Name: 'Running' },
  Successful: { Id: 4, Name: 'Successful' },
  Failed: { Id: 5, Name: 'Failed' },
  PartialSuccess: { Id: 6, Name: 'PartialSuccess' },
  Archived: { Id: 7, Name: 'Archived' },
  Complete: { Id: 8, Name: 'Complete' },
  OutOfSync: { Id: 9, Name: 'OutOfSync' },
  TimedOut: { Id: 10, Name: 'TimedOut' }
};

exports.ById = {
  1: { Id: 1, Name: 'NotReady' },
  2: { Id: 2, Name: 'ReadyToRun' },
  3: { Id: 3, Name: 'Running' },
  4: { Id: 4, Name: 'Successful' },
  5: { Id: 5, Name: 'Failed' },
  6: { Id: 6, Name: 'PartialSuccess' },
  7: { Id: 7, Name: 'Archived' },
  8: { Id: 8, Name: 'Complete' },
  9: { Id: 9, Name: 'OutOfSync' },
  10: { Id: 10, Name: 'TimedOut' }
};

exports.Meaning = {
  NotReady: 'PBA is not ready to run the comp search',
  ReadyToRun: 'PBA is ready to run comp search but the comp search has never been executed.',
  Running: 'CompSearch is currently running.',
  Successful: 'CompSearch has ran and all expected PLI comp searches have finished successfully.',
  Failed: 'All reported PLI CompSearches have failed.',
  PartialSuccess: 'Some PLI CompSearches have failed and some have passed.',
  Archived: 'CompSearch has been archived and a newer version has replaced it.',
  Complete: 'CompSearch is complete (i.e. report has been generated). No more changes are allowed. - Not Implemented.',
  OutOfSync: 'PBA is out of sync with the existing comp search. - Not Implemented.',
  TimedOut: 'CompSearch has been in a Running state for longer than 10 minutes with no success or failures reported.'
};
